var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8295_13937)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7513 24.1308L17.1169 25.3827L18.401 26.0012L19.0354 24.7492L17.7513 24.1308Z",
    fill: "#295DD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61369 11.4576L0.0613272 0.617942C-0.0292483 0.402694 -0.0179263 0.15341 0.0849146 0.0614237C0.188699 -0.0305629 0.443443 -0.0186046 0.655729 0.0890196L11.3172 5.48863L4.61369 11.4576Z",
    fill: "#295DD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33227 4.4834L3.33447 8.4103L3.69206 9.2621L10.2673 4.95713L9.33227 4.4834Z",
    fill: "#FF445D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29753 5.94228L6.62156 3.11094L5.68656 2.63721L1.93994 5.09049L2.29753 5.94228Z",
    fill: "#FF445D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.54541 1.76975L0.902995 2.62155L2.97585 1.26475L2.04085 0.791016L0.54541 1.76975Z",
    fill: "#FF445D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9989 15.1244C24.9989 20.9701 20.138 25.7084 14.1421 25.7084C8.14622 25.7084 3.28345 20.9701 3.28345 15.1244C3.28345 9.27863 8.14433 4.54041 14.1421 4.54041C20.1399 4.54041 24.9989 9.27955 24.9989 15.1244Z",
    fill: "url(#paint0_radial_8295_13937)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.9989 15.1244C24.9989 20.9701 20.138 25.7084 14.1421 25.7084C8.14622 25.7084 3.28345 20.9701 3.28345 15.1244C3.28345 9.27863 8.14433 4.54041 14.1421 4.54041C20.1399 4.54041 24.9989 9.27955 24.9989 15.1244Z",
    fill: "url(#paint1_radial_8295_13937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M24.9989 15.1244C24.9989 20.9701 20.138 25.7084 14.1421 25.7084C8.14622 25.7084 3.28345 20.9701 3.28345 15.1244C3.28345 9.27863 8.14433 4.54041 14.1421 4.54041C20.1399 4.54041 24.9989 9.27955 24.9989 15.1244Z",
    fill: "url(#paint2_radial_8295_13937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.9989 15.1244C24.9989 20.9701 20.138 25.7084 14.1421 25.7084C8.14622 25.7084 3.28345 20.9701 3.28345 15.1244C3.28345 9.27863 8.14433 4.54041 14.1421 4.54041C20.1399 4.54041 24.9989 9.27955 24.9989 15.1244Z",
    fill: "url(#paint3_radial_8295_13937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M24.9989 15.1244C24.9989 20.9701 20.138 25.7084 14.1421 25.7084C8.14622 25.7084 3.28345 20.9701 3.28345 15.1244C3.28345 9.27863 8.14433 4.54041 14.1421 4.54041C20.1399 4.54041 24.9989 9.27955 24.9989 15.1244Z",
    fill: "url(#paint4_radial_8295_13937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M21.7127 10.2804C21.7127 12.9554 18.3228 15.1244 14.1421 15.1244C9.96151 15.1244 6.57153 12.9554 6.57153 10.2804C6.57153 7.60544 9.96057 5.4364 14.1421 5.4364C18.3237 5.4364 21.7127 7.60544 21.7127 10.2804Z",
    fill: "url(#paint5_radial_8295_13937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.9989 15.1244C24.9989 20.9701 20.138 25.7084 14.1421 25.7084C8.14622 25.7084 3.28345 20.9701 3.28345 15.1244C3.28345 9.27863 8.14433 4.54041 14.1421 4.54041C20.1399 4.54041 24.9989 9.27955 24.9989 15.1244Z",
    fill: "url(#paint6_radial_8295_13937)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6945 13.9663C19.0351 14.4299 19.2134 14.6709 19.254 14.3848C19.2795 14.2156 19.2918 14.0408 19.2918 13.8624C19.2918 12.3409 18.4002 11.1083 17.2991 11.1083C16.198 11.1083 15.3074 12.3418 15.3074 13.8624C15.3074 14.0408 15.3196 14.2156 15.3442 14.3848C15.3847 14.67 15.564 14.4299 15.9055 13.9663C16.2631 13.476 16.7556 13.1743 17.2991 13.1743C17.8425 13.1743 18.335 13.476 18.6936 13.9663H18.6945Z",
    fill: "url(#paint7_radial_8295_13937)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2541 14.3857C19.2135 14.6709 19.0342 14.4308 18.6946 13.9672C18.3351 13.4769 17.8445 13.1752 17.3001 13.1752C16.7557 13.1752 16.2641 13.4769 15.9066 13.9672C15.565 14.4308 15.3857 14.6718 15.3452 14.3857C15.3235 14.2312 15.3131 14.0711 15.3103 13.9074C15.3103 13.9221 15.3093 13.9368 15.3093 13.9506C15.3093 14.1291 15.3216 14.3038 15.3461 14.4731C15.3867 14.7601 15.566 14.5191 15.9075 14.0536C16.2651 13.5652 16.7576 13.2616 17.301 13.2616C17.8445 13.2616 18.337 13.5643 18.6955 14.0536C19.0361 14.5191 19.2145 14.7592 19.255 14.4731C19.2805 14.3038 19.2928 14.1291 19.2928 13.9506C19.2928 13.9359 19.2918 13.9212 19.2918 13.9074C19.289 14.0711 19.2786 14.2312 19.255 14.3857H19.2541Z",
    fill: "url(#paint8_radial_8295_13937)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3788 13.9663C12.7194 14.4299 12.8978 14.6709 12.9383 14.3848C12.9629 14.2156 12.9751 14.0408 12.9751 13.8624C12.9751 12.3409 12.0835 11.1083 10.9834 11.1083C9.8833 11.1083 8.9917 12.3418 8.9917 13.8624C8.9917 14.0408 9.00396 14.2156 9.0285 14.3848C9.06907 14.67 9.24833 14.4299 9.58799 13.9663C9.94557 13.476 10.439 13.1743 10.9825 13.1743C11.5259 13.1743 12.0184 13.476 12.377 13.9663H12.3788Z",
    fill: "url(#paint9_radial_8295_13937)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9384 14.3857C12.8978 14.6709 12.7186 14.4308 12.3789 13.9672C12.0194 13.4769 11.5279 13.1752 10.9844 13.1752C10.441 13.1752 9.94753 13.4769 9.58994 13.9672C9.24934 14.4308 9.07102 14.6718 9.03045 14.3857C9.0078 14.2312 8.99648 14.0711 8.99554 13.9074C8.99365 13.9221 8.99365 13.9368 8.99365 13.9506C8.99365 14.1291 9.00592 14.3038 9.03045 14.4731C9.07102 14.7601 9.25028 14.5191 9.58994 14.0536C9.94753 13.5652 10.441 13.2616 10.9844 13.2616C11.5279 13.2616 12.0204 13.5643 12.3789 14.0536C12.7195 14.5191 12.8978 14.7592 12.9384 14.4731C12.9629 14.3038 12.9752 14.1291 12.9752 13.9506C12.9752 13.9359 12.9752 13.9212 12.9743 13.9074C12.9733 14.0711 12.962 14.2312 12.9393 14.3857H12.9384Z",
    fill: "url(#paint10_radial_8295_13937)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    d: "M24.062 15.7121C24.062 18.2537 22.5769 20.3142 20.7446 20.3142C18.9124 20.3142 17.4292 18.2537 17.4292 15.7121C17.4292 13.1705 18.9143 11.1091 20.7446 11.1091C22.575 11.1091 24.062 13.1696 24.062 15.7121Z",
    fill: "url(#paint11_radial_8295_13937)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    d: "M4.22217 15.7121C4.22217 18.2537 5.70723 20.3142 7.53761 20.3142C9.36799 20.3142 10.8549 18.2537 10.8549 15.7121C10.8549 13.1705 9.36988 11.1091 7.53761 11.1091C5.70534 11.1091 4.22217 13.1696 4.22217 15.7121Z",
    fill: "url(#paint12_radial_8295_13937)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.414 18.6861C16.4423 18.6282 16.4668 18.5684 16.4913 18.5104C16.5442 18.3945 16.5621 18.2657 16.5876 18.1425L16.597 17.9548L16.5998 17.907V17.8895L16.597 17.8481L16.5942 17.8306L16.5829 17.7571L16.5583 17.6117C16.5489 17.5584 16.5215 17.4839 16.4998 17.4213C16.4753 17.3597 16.4555 17.2888 16.4225 17.2364L16.3225 17.08C16.264 16.9715 16.1621 16.8933 16.0828 16.8041C15.9922 16.725 15.8903 16.6541 15.7856 16.5962C15.6714 16.5529 15.5686 16.4895 15.4497 16.4702C15.3327 16.4453 15.2195 16.415 15.0997 16.4242L14.928 16.4278C14.8497 16.438 14.8214 16.4499 14.7638 16.4619C14.6638 16.4849 14.5647 16.506 14.4657 16.5336C14.2637 16.6054 14.0675 16.6799 13.8797 16.7627C14.0883 16.7636 14.2883 16.7562 14.4826 16.747C14.5845 16.7553 14.6864 16.7562 14.7874 16.7599C14.8317 16.7627 14.9044 16.7627 14.9251 16.7664L15.0544 16.7995C15.1412 16.8124 15.2186 16.8519 15.294 16.8869C15.3724 16.9135 15.4327 16.9798 15.5016 17.0193C15.5601 17.0764 15.6195 17.1306 15.6696 17.1886C15.7092 17.2585 15.7686 17.31 15.7903 17.3854L15.8366 17.4903C15.8516 17.5243 15.8488 17.5538 15.8564 17.5841C15.8601 17.6172 15.8752 17.6329 15.88 17.6779L15.8884 17.826L15.8913 17.8996V17.9024C15.8903 17.8665 15.8913 17.8987 15.8913 17.8849V17.8877L15.8903 17.8904V17.8969L15.8837 17.9245C15.8771 17.9603 15.8733 17.9944 15.8686 18.0303C15.8441 18.0974 15.8347 18.1692 15.7969 18.2299L15.7479 18.3237L15.6856 18.4083C15.645 18.4653 15.5894 18.5123 15.5365 18.5592C15.4799 18.6015 15.4252 18.6447 15.3591 18.6732C15.2997 18.7146 15.228 18.7238 15.1629 18.7514H15.1601C15.0704 18.7928 14.995 18.8637 14.9516 18.9584C14.8563 19.1644 14.9516 19.4055 15.1629 19.4974C15.228 19.525 15.3006 19.5342 15.361 19.5756C15.4271 19.6032 15.4818 19.6483 15.5384 19.6897C15.5912 19.7375 15.6469 19.7835 15.6875 19.8415L15.7507 19.9261C15.7639 19.9592 15.7809 19.9896 15.7979 20.0208C15.8186 20.054 15.8262 20.0806 15.8347 20.1064C15.8432 20.1386 15.8592 20.1496 15.8658 20.1975L15.8856 20.3446L15.8894 20.3778V20.3814L15.8866 20.4366L15.8847 20.5461C15.879 20.5829 15.8658 20.6178 15.8601 20.6546C15.8516 20.7301 15.8167 20.7972 15.7865 20.8671C15.7639 20.9425 15.7026 20.9959 15.6629 21.064C15.6101 21.121 15.5535 21.179 15.4922 21.2314C15.4261 21.2709 15.3582 21.3399 15.2903 21.3611L15.1855 21.4126C15.1487 21.431 15.0893 21.4338 15.0431 21.4466L14.9676 21.465L14.9308 21.4733L14.9119 21.477H14.9082L14.9072 21.4779L14.7713 21.4843L14.4798 21.4972C14.2741 21.4862 14.0694 21.477 13.8618 21.477C14.0505 21.5607 14.2411 21.6343 14.4336 21.706C14.5355 21.7355 14.6411 21.7566 14.7478 21.7815L14.91 21.8164L15.0808 21.8229C15.1346 21.8219 15.178 21.8293 15.2393 21.8192L15.4252 21.7824C15.5592 21.7612 15.6545 21.7014 15.7705 21.6573C15.8781 21.6021 15.9762 21.5276 16.0715 21.4522C16.1517 21.362 16.2526 21.2829 16.314 21.1762C16.3819 21.0732 16.4508 20.9701 16.4885 20.8496C16.5121 20.7917 16.5347 20.7337 16.5498 20.6721L16.58 20.4881L16.5923 20.3943L16.5951 20.3704V20.3649L16.5961 20.3621V20.329L16.5951 20.3198V20.283L16.5866 20.1349C16.5687 20.0199 16.5395 19.8507 16.4885 19.7421C16.4715 19.6998 16.4536 19.6575 16.4357 19.6152C16.4215 19.5839 16.4055 19.5536 16.3866 19.5241L16.3074 19.4036C16.2385 19.2987 16.1488 19.2077 16.0564 19.1203C16.1488 19.0357 16.2357 18.9455 16.3055 18.8425L16.4102 18.6815L16.414 18.6861Z",
    fill: "url(#paint13_radial_8295_13937)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2185 19.6953C24.2081 19.6953 24.1987 19.6953 24.1883 19.6953L16.479 19.6833C16.3309 19.6833 16.1875 19.6318 16.0733 19.5398L15.8629 19.3687C15.795 19.3135 15.7544 19.2316 15.7525 19.1443C15.7506 19.0569 15.7874 18.9741 15.8544 18.9161L16.0695 18.7266C16.1865 18.6236 16.3375 18.5675 16.495 18.5675L24.1949 18.5804C24.2006 18.5804 24.2072 18.5804 24.2128 18.5804C25.1129 18.5804 25.846 17.8748 25.8555 17C25.8602 16.5374 25.4799 16.1574 25.0063 16.1501H25.0044C24.778 16.1501 24.5723 16.2393 24.4232 16.3837C24.5185 16.3479 24.6232 16.3313 24.727 16.3304C24.9818 16.3331 25.2205 16.4325 25.3988 16.61C25.5771 16.7876 25.6734 17.0221 25.6705 17.2705C25.6668 17.5722 25.5441 17.8546 25.3224 18.0662C25.1007 18.2777 24.8101 18.39 24.4987 18.389C24.1043 18.3854 23.7354 18.2317 23.459 17.9567C23.1825 17.6817 23.0335 17.3183 23.0372 16.9338C23.0486 15.8833 23.9298 15.0361 25.0044 15.0361H25.0176C25.0176 15.0361 25.0223 15.0361 25.0252 15.0361C26.1262 15.0527 27.0112 15.9376 26.9999 17.0129C26.9839 18.4985 25.7394 19.6971 24.2185 19.6971V19.6953ZM24.6299 17.4241C24.6676 17.4382 24.6965 17.4456 24.7167 17.4462H24.7195C24.8035 17.4462 24.8865 17.4131 24.9469 17.356C25.0082 17.2981 25.0431 17.2162 25.044 17.1334C25.045 17.0295 25.0025 16.9255 24.9271 16.8501C24.8516 16.7747 24.727 16.7351 24.5978 16.7738C24.3506 16.8648 24.2534 17.2337 24.6299 17.425V17.4241Z",
    fill: "#295DD7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9016 17.39C24.9195 17.402 24.9384 17.413 24.9591 17.424C24.9969 17.4381 25.0258 17.4455 25.0459 17.4461H25.0488C25.1327 17.4461 25.2158 17.413 25.2761 17.356C25.3375 17.298 25.3724 17.2162 25.3733 17.1334C25.3743 17.0294 25.3318 16.9255 25.2563 16.85C25.1809 16.7746 25.0563 16.7351 24.9271 16.7737C24.9054 16.782 24.8855 16.7921 24.8657 16.8041C24.8884 16.8169 24.9082 16.8326 24.9261 16.85C25.0016 16.9255 25.044 17.0294 25.0431 17.1334C25.0431 17.2162 25.0063 17.298 24.9459 17.356C24.9318 17.3688 24.9167 17.3808 24.9006 17.3909L24.9016 17.39Z",
    fill: "#1749BF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8912 16.3469C24.8638 16.3423 24.8374 16.3386 24.8091 16.3358C24.7902 16.3515 24.7714 16.3671 24.7544 16.3846C24.7987 16.368 24.844 16.3561 24.8912 16.3469Z",
    fill: "#1749BF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5251 18.5803C24.5308 18.5803 24.5364 18.5803 24.543 18.5803C25.4431 18.5803 26.1762 17.8748 26.1856 17C26.1904 16.5373 25.8101 16.1574 25.3365 16.15H25.3346C25.2761 16.15 25.2195 16.1565 25.1648 16.1675C25.4535 16.2245 25.6894 16.4223 25.795 16.6845C25.9309 16.851 26.0026 17.0561 26.0007 17.2713C25.9979 17.5731 25.8743 17.8555 25.6526 18.067C25.4771 18.2344 25.2572 18.3384 25.0195 18.3743C24.7836 18.504 24.5128 18.5785 24.2241 18.5812H24.5251V18.5803Z",
    fill: "#1749BF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8092 19.6832C16.6611 19.6832 16.5177 19.6326 16.4035 19.5397L16.1931 19.3686C16.1252 19.3135 16.0846 19.2316 16.0827 19.1442C16.0808 19.0577 16.1176 18.974 16.1837 18.9161L16.3988 18.7266C16.513 18.6263 16.6592 18.5711 16.8121 18.5684H16.4941C16.3365 18.5684 16.1856 18.6245 16.0686 18.7266L15.8535 18.9161C15.7874 18.974 15.7506 19.0568 15.7525 19.1442C15.7544 19.2307 15.794 19.3125 15.8629 19.3686L16.0733 19.5397C16.1875 19.6326 16.3309 19.6832 16.479 19.6832L24.1883 19.6961C24.1987 19.6961 24.2081 19.6961 24.2185 19.6961C24.226 19.6961 24.2326 19.6961 24.2402 19.6961L16.8092 19.6842V19.6832Z",
    fill: "#1749BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4996 18.3881C24.5553 18.3881 24.61 18.3835 24.6638 18.377C24.3326 18.3375 24.0269 18.1921 23.7901 17.9557C23.5137 17.6807 23.3646 17.3173 23.3684 16.9328C23.3788 15.9403 24.1656 15.1308 25.1582 15.0434C25.1148 15.0398 25.0704 15.0361 25.0261 15.0352C25.0233 15.0352 25.0214 15.0352 25.0186 15.0352H25.0053C23.9298 15.0352 23.0495 15.8824 23.0382 16.9328C23.0344 17.3173 23.1844 17.6807 23.4599 17.9557C23.7363 18.2308 24.1053 18.3844 24.4996 18.3881Z",
    fill: "#1749BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.7048C26.5206 16.6293 26.3121 16.6855 26.1536 16.8179C26.0083 16.9384 25.9121 17.0893 25.8375 17.2162C25.8168 17.356 25.7781 17.4903 25.7224 17.6164C25.7356 17.6449 25.7564 17.6734 25.7837 17.7028C25.8036 17.7212 25.8271 17.7534 25.8526 17.7792C25.879 17.8068 25.9083 17.8334 25.9404 17.8601C26.0696 17.9641 26.2423 18.068 26.4489 18.1066C26.5527 18.126 26.6565 18.1241 26.7537 18.0993C26.9084 17.7672 26.9961 17.3993 27.0008 17.012C27.0008 16.9679 26.998 16.9237 26.9952 16.8805C26.9169 16.7986 26.8263 16.737 26.7329 16.7057L26.732 16.7048Z",
    fill: "#FF445D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3149 19.3364C24.2705 19.2702 24.1922 19.215 24.1082 19.1773C24.0243 19.1396 23.9328 19.1184 23.8356 19.1184C23.5025 19.1184 23.2223 19.364 23.1497 19.6933L24.1894 19.6952C24.1998 19.6952 24.2092 19.6952 24.2196 19.6952C24.313 19.6952 24.4045 19.6906 24.4951 19.6814C24.4526 19.548 24.3856 19.4312 24.3158 19.3355L24.3149 19.3364Z",
    fill: "#FF445D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3069 19.6888C20.2371 19.3585 19.9597 19.112 19.6266 19.1111C19.2936 19.1111 19.0143 19.3567 18.9417 19.686L20.3069 19.6878V19.6888Z",
    fill: "#FF445D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3901 18.5693C22.3203 18.8996 22.0429 19.1461 21.7099 19.147C21.3768 19.147 21.0976 18.9014 21.0249 18.5721L22.3901 18.5703V18.5693Z",
    fill: "#FF445D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4591 17.9558C23.6157 18.1122 23.8034 18.2272 24.0082 18.2998C24.1252 18.1527 24.1978 17.9898 24.2761 17.8813C24.3563 17.7571 24.4328 17.7102 24.4309 17.6835C24.4309 17.6799 24.429 17.6762 24.4261 17.6716C24.4233 17.6661 24.4205 17.6513 24.4158 17.6421C24.4073 17.621 24.3941 17.5989 24.378 17.5759C24.346 17.5299 24.3007 17.4793 24.2469 17.4232C24.1374 17.3128 23.9978 17.1712 23.8082 17.0792C23.6213 16.9881 23.4043 16.9817 23.2185 17.1068C23.1647 17.1426 23.1147 17.1905 23.0713 17.2466C23.1288 17.5115 23.2609 17.7571 23.46 17.9549L23.4591 17.9558Z",
    fill: "#FF445D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9831 18.3228H17.1169V19.9022H17.9831V18.3228Z",
    fill: "#1749BF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0253 15.0352C25.0253 15.0352 25.0206 15.0352 25.0177 15.0352H25.0045C24.8045 15.0352 24.612 15.0646 24.4299 15.1189C24.4299 15.1207 24.4299 15.1225 24.4299 15.1244C24.4299 15.5346 24.7715 15.8676 25.1923 15.8676C25.5631 15.8676 25.8716 15.6101 25.9405 15.2688C25.6669 15.1253 25.3564 15.0407 25.0253 15.0352Z",
    fill: "#FF445D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9681 2.16837L18.3337 3.42029L19.6178 4.03875L20.2522 2.78683L18.9681 2.16837Z",
    fill: "#295DD7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49485 18.0334L1.09229 18.316L1.38223 19.6835L2.7848 19.4008L2.49485 18.0334Z",
    fill: "#295DD7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7921 22.7489L22.2007 24.0206L23.5051 24.5972L24.0965 23.3255L22.7921 22.7489Z",
    fill: "#FF445D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76529 23.7604L4.36938 24.0729L4.68986 25.4338L6.08577 25.1214L5.76529 23.7604Z",
    fill: "#FFBF00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9633 4.02295L10.6506 5.38562L12.0483 5.69046L12.361 4.32779L10.9633 4.02295Z",
    fill: "#FFBF00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9542 8.44334L21.5488 8.71265L21.8251 10.0828L23.2304 9.81348L22.9542 8.44334Z",
    fill: "#FF445D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.495 20.0714) scale(14.3977 14.0371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F7B836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FAC947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD957"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2686 12.0125) scale(11.3502 11.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B48700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#674D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2F2300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0D0900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2686 12.0125) scale(13.0353 12.7089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FEFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FEF2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FDE497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCD04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1412 15.1244) scale(10.8568 10.5849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0D0B06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2F2917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#675A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB9654"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1412 15.2173) scale(11.2465 10.9648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCF5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F9E9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F6D7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F0C0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EAA58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E38460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE6E43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1421 4.14421) scale(18.1991 10.2911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1412 12.7944) scale(14.5534 14.1889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3765 14.294) scale(6.23839 3.16272)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2E1B07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#58340E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#734413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D4A15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3765 14.3815) scale(6.23933 3.1632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F8C148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F8D68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DA97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0598 -376.723) scale(6.23745 3.16224)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2E1B07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#58340E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#734413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D4A15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0599 -376.723) scale(6.23839 3.16272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F8C148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F8D68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DA97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7456 15.704) scale(3.3162 4.60723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BB9387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E1CFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.53799 26.5937) rotate(180) scale(0.0566097 0.0786485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BB9387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E1CFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_8295_13937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9508 19.6713) scale(2.60405 6.7279)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2E1B07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#58340E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#734413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D4A15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8295_13937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.01781cbea38f7503119701be7465b7fb.svg";
export { ForwardRef as ReactComponent };